import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { putInternalParcelPickup } from '../../../../actions';
import Modal from '../../../common/modal/Modal';
import DeliverInternalParcelForm from './DeliverInternalParcelForm';

const DeliverInternalParcelButton = ({
  internalParcelId,
  internalParcel,
  dispatchPutInternalParcelPickup,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const openModal = async () => {
    setShowModal(true);
  };

  const handleDeliverInternalParcel = (formvalues) => {
    dispatchPutInternalParcelPickup(internalParcelId, formvalues);
  };

  const closeModal = () => setShowModal(false);

  const buildModalBody = () => {
    const newModalBody = (
      <DeliverInternalParcelForm
        onCancel={closeModal}
        onSubmit={handleDeliverInternalParcel}
        internalParcel={internalParcel}
      />
    );
    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal !== false) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Button
        color="success"
        className="border"
        onClick={openModal}
        disabled={!internalParcelId}
      >
        <i className="fa fa-truck" /> Entregar
      </Button>
      <Modal
        show={showModal}
        title="Entregar Traslado Interno"
        body={modalBody}
        size="lg"
        onClickCancel={closeModal}
        onClickClose={closeModal}
      />
    </>
  );
};

DeliverInternalParcelButton.propTypes = {
  internalParcelId: PropTypes.string.isRequired,
  dispatchPutInternalParcelPickup: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  internalParcel: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  dispatchPutInternalParcelPickup: putInternalParcelPickup,
};

export default connect(null, mapDispatchToProps)(DeliverInternalParcelButton);
